/** @jsx jsx */
import { jsx } from "theme-ui"
import Select from "react-select"

// UI-facing semantic values; /api/properties translates these to the
// upstream MLS enum. "for-sale" covers MLS ACTIVE + PENDING plus non-sold
// Sanity rows; "sold" is Sanity-curated only (upstream carries no closed
// listings for this tenant).
const STATUS_OPTIONS = [
  { value: "for-sale", label: "For Sale" },
  { value: "sold", label: "Sold" },
]

const StatusFilter = ({ className, value, onChange }) => {
  const selected = STATUS_OPTIONS.filter(o => value.includes(o.value))

  const handleChange = data => {
    if (!data || data.length === 0) {
      onChange([])
      return
    }
    onChange(data.map(d => d.value))
  }

  return (
    <Select
      className={className}
      options={STATUS_OPTIONS}
      value={selected}
      isSearchable={true}
      isMulti
      onChange={handleChange}
      placeholder="Any"
    />
  )
}

export default StatusFilter
